import axios from 'axios';

import { ValidatePartnerCustomerIdResponse } from '~/types/partner';

export const validateRacqMemberId = async (value?: string) => {
  try {
    if (value === undefined) return null;

    const cleanedId = value.replaceAll(/\s/g, '');
    if (cleanedId.length !== 16 || !/^\d{16}$/.test(cleanedId)) {
      return false;
    }

    const { data } = await axios.post<ValidatePartnerCustomerIdResponse>(`/api/premarketplace/partners/validate-id`, {
      partnerCustomerId: cleanedId,
      partner: 'racq',
    });
    return data.isValid;
  } catch (error) {
    console.error('[BrightePremarketplace] Error validating RACQ member ID:', error);
    return null;
  }
};
